<div
  class="tw-mb-2 tw-flex tw-flex-col tw-rounded-lg tw-border tw-text-sm tw-shadow-md"
>
  <!-- begin::Summary -->
  <app-summary></app-summary>
  <!-- end::Summary -->

  <!-- begin::Detail -->
  <div class="tw-p-[0.3125rem]">
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="tw-flex">
      @if (tabsAvailable().includes(TripSummaryTab.Passengers)) {
        <li class="tw-flex-1" [ngbNavItem]="TripSummaryTab.Passengers">
          <button
            ngbNavLink
            class="tw-w-full tw-rounded-md hover:tw-text-secondary [&.active]:tw-bg-blue-600 [&.active]:tw-text-secondary-content"
          >
            Hành khách
          </button>
          <ng-template ngbNavContent>
            <app-passengers></app-passengers>
          </ng-template>
        </li>
      }

      @if (tabsAvailable().includes(TripSummaryTab.Itinerary)) {
        <li class="tw-flex-1" [ngbNavItem]="TripSummaryTab.Itinerary">
          <button
            ngbNavLink
            class="tw-size-full tw-rounded-md hover:tw-text-secondary [&.active]:tw-bg-blue-600 [&.active]:tw-text-secondary-content"
          >
            Hành trình
          </button>
          <ng-template ngbNavContent>
            <app-itinerary></app-itinerary>
          </ng-template>
        </li>
      }

      @if (tabsAvailable().includes(TripSummaryTab.TicketPrices)) {
        <li class="tw-flex-1" [ngbNavItem]="TripSummaryTab.TicketPrices">
          <button
            ngbNavLink
            class="tw-size-full tw-rounded-md hover:tw-text-secondary [&.active]:tw-bg-blue-600 [&.active]:tw-text-secondary-content"
          >
            Giá vé
          </button>
          <ng-template ngbNavContent>
            <app-ticket-prices></app-ticket-prices>
          </ng-template>
        </li>
      }

      @if (tabsAvailable().includes(TripSummaryTab.TicketConditions)) {
        <li class="tw-flex-1" [ngbNavItem]="TripSummaryTab.TicketConditions">
          <button
            ngbNavLink
            class="tw-size-full tw-rounded-md hover:tw-text-secondary [&.active]:tw-bg-blue-600 [&.active]:tw-text-secondary-content"
          >
            Điều kiện vé
          </button>
          <ng-template ngbNavContent>
            <app-ticket-rules></app-ticket-rules>
          </ng-template>
        </li>
      }
    </ul>

    <div [ngbNavOutlet]="nav"></div>
  </div>
  <!-- end::Detail -->
</div>
